var map = {
	"./fondos/main_fondo.png": 324,
	"./fondos/rAmazon.jpg": 325,
	"./logos/main-app-black-(orig).png": 326,
	"./logos/main-app-black.png": 327,
	"./logos/main-app-blue-(orig).png": 328,
	"./logos/main-app-blue.png": 329,
	"./logos/main-app-white-(orig).png": 330,
	"./logos/main-app-white.png": 331,
	"./logos/main_logo.png": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;